module.exports = __webpack_public_path__ + "static/media/hamburger.1eb46fe7.svg";